import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WalletPointsTransactionService } from '../../services/wallet-points-transaction.service';
import { VendorPointsByMonth, VendorPointsHistory } from '../../model/vendor-wallet-points-transactions';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-vendor-wallet-transaction',
  templateUrl: './vendor-wallet-transaction.component.html',
  styles: ``
})
export class VendorWalletTransactionComponent {
  @Input() id!: string;
  @Input() currentPoints!: number;
  dataLoading = false;
  @Output() close = new EventEmitter<boolean>();

  selectedRequest!: any;

  vendorPoints!: VendorPointsHistory | null;
  vendorPointsLoading = false;

  vendorPointsByMonthLoading = false;

  today = new Date();

  constructor(private service: WalletPointsTransactionService,
    private dialog: MatDialog) {
  }


  ngOnInit(): void {
    this.vendorPointsHistory();
  }

  vendorPointsHistory() {
    this.vendorPointsByMonthLoading = true;
    this.service.VendorPointsHistory(this.id).subscribe((res: VendorPointsHistory) => {
      this.vendorPoints = res;
      this.vendorPointsByMonthLoading = false;
    })
  }

  getVendorHistoryByMonth(year_and_month: any, i: number) {
    this.vendorPoints!.data[i].loading = true;
    this.service.GetVendorPointsHistoryByMonth(this.id, year_and_month).subscribe((res: VendorPointsByMonth) => {
      this.vendorPoints!.data[i].history = res;
      this.vendorPoints!.data[i].loading = false;

      this.vendorPoints!.data[i].history.data.map((item) => {
        item.isShow = false;
      });
    })
  }

  ShowHideDetails(i: any,x: any, isShow: boolean) {
    let target = this.vendorPoints!.data[i].history.data[x];
    target.isShow = isShow;
    this.updateExpireAter(target)
    window.setInterval(() => {
      this.updateExpireAter(target)
    }, 1000)
  }

  updateExpireAter(target: any) {
    if (target.message.expire_after > 0) {
      target.message.expire_after = target.message.expire_after - 1;
    }
  }

}
